import { render } from "./CustomizationSwatchTooltip.vue?vue&type=template&id=8991d91c"
import script from "./CustomizationSwatchTooltip.vue?vue&type=script&lang=js"
export * from "./CustomizationSwatchTooltip.vue?vue&type=script&lang=js"

import "./CustomizationSwatchTooltip.vue?vue&type=style&index=0&id=8991d91c&lang=scss"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__